import Axios from "@/plugins/Axios";

export class PlanosBimestraisAEEService {
  async index(pageNumber = 1, aluno = "", turma = "", bimestre = "") {
    const response = await Axios().get("planos-bimestrais-aee", {
      params: { page: pageNumber, aluno, turma, bimestre },
    });
    return response.data;
  }

  async show(planoId) {
    const response = await Axios().get(`planos-bimestrais-aee/${planoId}/visualizar`);
    return response.data;
  }

  async turmas() {
    const response = await Axios().get("planos-bimestrais-aee/turmas");
    return response.data;
  }

  async update(planoId, statusId) {
    const response = await Axios().put(
      `planos-bimestrais-aee/${planoId}/${statusId}/atualizar-situacao`
    );
    return response.data;
  }

  async cabecalho(matriculaId) {
    const response = await Axios().get(`planos-bimestrais-aee/matricula/${matriculaId}/cabecalho`);
    return response.data;
  }

  async plano(matriculaId, bimestre) {
    const response = await Axios().get(
      `planos-bimestrais-aee/matricula/${matriculaId}/bimestre/${bimestre}`
    );
    return response.data.plano;
  }

  async salvar(matriculaId, form) {
    const response = await Axios().post(`planos-bimestrais-aee/matricula/${matriculaId}`, form);
    return response.data;
  }

  async pdf(matriculaId, bimestre) {
    const response = await Axios().get(
      `planos-bimestrais-aee/matricula/${matriculaId}/bimestre/${bimestre}/pdf`,
      { responseType: "arraybuffer" }
    );
    const blob = new Blob([response.data], { type: "application/pdf" });
    window.open(window.URL.createObjectURL(blob));
    return response;
  }
}

export default new PlanosBimestraisAEEService();
